var _path;
import * as React from "react";
function SvgChevronFillLeft(props) {
  return /*#__PURE__*/React.createElement("svg", props, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.341 6.691V33.31c0 2.393-2.896 3.59-4.585 1.9L11.447 21.902a2.673 2.673 0 010-3.791L24.756 4.79c1.689-1.689 4.585-.492 4.585 1.901z"
  })));
}
export default SvgChevronFillLeft;